import { FC, useState } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import useGetFlexographyMachines from '../../hooks/api/requests/use-get-flexography-machines'
import Machine from '../../types/api/machine'
import HelpDrawer from './components/help-drawer/help-drawer'
import MachinePicker from './components/machine-picker/machine-picker'
import OneMachineSchedule from './components/one-machine-schedule/one-machine-schedule'

interface MachinesSchedulePageProps {}

/**
 * Раздел для печатника
 * @returns
 */
export const MachinesSchedulePage: FC<MachinesSchedulePageProps> = () => {
    const [currentMachine, setCurrentMachine] = useState<Machine>()
    const { data } = useGetFlexographyMachines()
    const initialMachines = data?.data || []
    const sortedData = [...initialMachines].sort((a, b) => a.name.localeCompare(b.name))

    return (
        <PageLayout
            title={`План ${currentMachine?.name || ''}`}
            scrollableContent
            beforeUser={<HelpDrawer />}
        >
            {currentMachine ? (
                <OneMachineSchedule machine={currentMachine} />
            ) : (
                <MachinePicker
                    machines={sortedData}
                    onSelect={setCurrentMachine}
                    title='Выберите станок'
                    groupByBrand
                />
            )}
        </PageLayout>
    )
}

export default MachinesSchedulePage
